/* ==========================================================================
   cbp.js - Cardio Bundle PDP behaviour.
   Scoped to .cbp only. No globals other than window.CBP. Idempotent init so
   it survives Shopify theme-editor section re-renders.
   Add-to-cart is intentionally NOT handled here: the buy form is a
   <product-form> with .js-product-form, so the theme's main.js ProductForm
   takes it over and opens the cart drawer (settings.after_add_to_cart).
   ========================================================================== */
(function () {
  'use strict';

  var HEADER_FALLBACK = 71;

  function headerHeight() {
    var h = document.querySelector('.cbp-header-outer .cbp-header');
    return h ? h.getBoundingClientRect().height : HEADER_FALLBACK;
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ---------- Mobile nav ------------------------------------------------- */
  function initHeader(root) {
    var burger = root.querySelector('[data-cbp-burger]');
    var panel = root.querySelector('[data-cbp-mobile-nav]');
    if (!burger || !panel || burger.dataset.cbpReady === '1') return;
    burger.dataset.cbpReady = '1';

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }
    setOpen(false);

    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        burger.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 860) setOpen(false);
    });
  }

  /* ---------- Tabs ------------------------------------------------------- */
  function initTabs(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cbp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cbp-panel]'));
    if (!tabs.length) return;

    function select(index, focus) {
      each(tabs, function (t, i) {
        var on = i === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        t.classList.toggle('is-active', on);
      });
      each(panels, function (p, i) {
        p.hidden = i !== index;
      });
      if (focus && tabs[index]) tabs[index].focus();
    }

    each(tabs, function (t, i) {
      t.addEventListener('click', function () {
        select(i);
      });
      t.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next > -1) {
          e.preventDefault();
          select(next, true);
        }
      });
    });

    var initial = 0;
    each(tabs, function (t, i) {
      if (t.classList.contains('is-active')) initial = i;
    });
    select(initial);
  }

  /* ---------- Product gallery -------------------------------------------- */
  function initGallery(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cbp-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cbp-slide]'));
    if (!thumbs.length || !slides.length) return;

    function show(mediaId) {
      each(slides, function (s) {
        var on = s.getAttribute('data-cbp-slide') === String(mediaId);
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) {
          var v = s.querySelector('video');
          if (v && typeof v.pause === 'function') {
            try {
              v.pause();
            } catch (err) {
              /* ignore */
            }
          }
        }
      });
      each(thumbs, function (t) {
        var on = t.getAttribute('data-cbp-thumb') === String(mediaId);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    each(thumbs, function (t) {
      t.addEventListener('click', function () {
        show(t.getAttribute('data-cbp-thumb'));
      });
    });

    // Follow the selected variant's featured media when a variant changes.
    var buy = root.closest('[data-cbp-buy]');
    if (buy) {
      buy.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cbp-variant-media]');
        if (input) {
          var mid = input.getAttribute('data-cbp-variant-media');
          if (mid) show(mid);
        }
      });
    }

    var active = null;
    each(thumbs, function (t) {
      if (!active && t.classList.contains('is-active')) active = t;
    });
    if (!active) active = thumbs[0];
    if (active) show(active.getAttribute('data-cbp-thumb'));
  }

  /* ---------- Quantity stepper ------------------------------------------- */
  function initQty(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var input = root.querySelector('[data-cbp-qty-input]');
    if (!input) return;

    function clamp(v) {
      var min = parseInt(input.getAttribute('min'), 10);
      var max = parseInt(input.getAttribute('max'), 10);
      if (isNaN(min)) min = 1;
      if (!isNaN(max) && v > max) v = max;
      if (v < min) v = min;
      return v;
    }

    function step(by) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      input.value = clamp(v + by);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cbp-qty-down]')) {
        e.preventDefault();
        step(-1);
      }
      if (e.target.closest('[data-cbp-qty-up]')) {
        e.preventDefault();
        step(1);
      }
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      input.value = clamp(isNaN(v) ? 1 : v);
    });
  }

  /* ---------- Accordions: animated open/close ----------------------------- */
  /* Native <details> stays the source of truth (works with no JS, keyboard and
     screen readers), but the height is animated via the Web Animations API on
     an explicit .cbp-collapse wrapper. An explicit wrapper is required because
     Chrome puts a <details>'s non-summary children in an implicit
     ::details-content slot that cannot be targeted reliably. `is-closing`
     flips the +/- icon at the start of the close, not the end. */
  var ACC_MS = 260;

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initDetails(el) {
    if (el.dataset.cbpReady === '1') return;
    el.dataset.cbpReady = '1';

    var summary = null;
    var content = null;
    each(el.children, function (child) {
      if (!summary && child.tagName === 'SUMMARY') summary = child;
      if (!content && child.classList && child.classList.contains('cbp-collapse')) content = child;
    });
    if (!summary || !content) return;

    var anim = null;

    function clear() {
      el.classList.remove('is-animating', 'is-closing');
      content.style.height = '';
      content.style.opacity = '';
      anim = null;
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (prefersReduced()) {
        el.open = !el.open;
        return;
      }
      if (anim) {
        anim.cancel();
        clear();
      }

      if (!el.open) {
        el.open = true;
        var target = content.scrollHeight;
        el.classList.add('is-animating');
        anim = content.animate(
          [{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }],
          { duration: ACC_MS, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        anim.onfinish = clear;
        anim.oncancel = clear;
      } else {
        var from = content.scrollHeight;
        el.classList.add('is-animating', 'is-closing');
        anim = content.animate(
          [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: ACC_MS, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        anim.onfinish = function () {
          el.open = false;
          clear();
        };
        anim.oncancel = clear;
      }
    });
  }

  /* ---------- Video facade ------------------------------------------------ */
  /* Swaps the poster for the real embed on click, so YouTube's ~1MB of script
     never loads unless someone actually plays the video. */
  function initVideo(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var btn = root.querySelector('[data-cbp-video-play]');
    var src = root.getAttribute('data-cbp-video-src');
    if (!btn || !src) return;

    btn.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.className = 'cbp-video__frame';
      frame.setAttribute('src', src);
      frame.setAttribute('title', root.getAttribute('data-cbp-video-title') || 'Video');
      frame.setAttribute('frameborder', '0');
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      root.innerHTML = '';
      root.appendChild(frame);
    });
  }

  /* ---------- Modal ------------------------------------------------------- */
  /* Used by the buy box's "Learn more" links. Focus is trapped loosely: focus
     moves into the panel on open and back to the opener on close, Escape and a
     click on the scrim both dismiss. */
  var modalOpener = null;

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (modalOpener && typeof modalOpener.focus === 'function') modalOpener.focus();
    modalOpener = null;
  }

  function openModal(modal, opener) {
    if (!modal) return;
    modalOpener = opener || null;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = modal.querySelector('.cbp-modal__close');
    if (focusable) focusable.focus();
  }

  function initModals() {
    if (document.documentElement.getAttribute('data-cbp-modals') === '1') return;
    document.documentElement.setAttribute('data-cbp-modals', '1');

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cbp-modal-open]');
      if (opener) {
        var modal = document.getElementById(opener.getAttribute('data-cbp-modal-open'));
        if (modal) {
          e.preventDefault();
          openModal(modal, opener);
        }
        return;
      }
      var closer = e.target.closest('[data-cbp-modal-close]');
      if (closer) {
        e.preventDefault();
        closeModal(closer.closest('[data-cbp-modal]'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      each(document.querySelectorAll('[data-cbp-modal]'), function (m) {
        if (!m.hidden) closeModal(m);
      });
    });
  }

  /* ---------- Variant picker --------------------------------------------- */
  /* Only rendered when the product has more than one variant. Keeps the
     hidden [name="id"] the theme's ProductForm posts in sync with the select,
     and mirrors price / availability / featured media. */
  function initVariants(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var select = root.querySelector('[data-cbp-variant-select]');
    if (!select) return;

    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-cbp-price]');
    var totalEl = root.querySelector('[data-cbp-total-price]');
    var addBtn = root.querySelector('[name="add"]');
    var soldOut = addBtn ? addBtn.getAttribute('data-sold-out-text') : '';
    var addText = addBtn ? addBtn.getAttribute('data-add-to-cart-text') : '';

    function apply() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      if (idInput) idInput.value = opt.value;

      var price = opt.getAttribute('data-price');
      if (price) {
        if (priceEl) priceEl.textContent = price;
        if (totalEl) totalEl.textContent = price;
      }

      if (addBtn) {
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        var label = addBtn.querySelector('.cbp-atc__label');
        if (label) label.textContent = available ? addText : soldOut;
      }

      var media = opt.getAttribute('data-media');
      if (media) {
        var gallery = root.closest('[data-cbp-buy]');
        if (gallery) {
          var thumb = gallery.querySelector('[data-cbp-thumb="' + media + '"]');
          if (thumb) thumb.click();
        }
      }
    }

    select.addEventListener('change', apply);
    apply();
  }

  /* ---------- Mobile card carousels -------------------------------------- */
  function initCarousel(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';

    var track = root.querySelector('[data-cbp-carousel-track]');
    var prev = root.querySelector('[data-cbp-carousel-prev]');
    var next = root.querySelector('[data-cbp-carousel-next]');
    if (!track) return;

    function stepSize() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      if (isNaN(gap)) gap = 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      // The track carries a gutter padding and scroll-snap-align:start, so its
      // resting scrollLeft is the left padding, not 0. 2px tolerance on top,
      // because fractional scroll positions never land exactly on the end.
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var atStart = track.scrollLeft <= padL + 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    // Card widths are not final until layout and web fonts settle, so the
    // first sync can see scrollWidth == clientWidth. Re-run once settled.
    requestAnimationFrame(sync);
    window.addEventListener('load', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  }

  /* ---------- Uploaded video behind a play badge -------------------------
     The markup ships the <video> with no control bar and a button on top of
     it, so the card reads as a poster frame. First press hands the viewer a
     normal player. -------------------------------------------------------- */
  function initNativeVideo(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';
    var btn = root.querySelector('[data-cbp-video-native-play]');
    var vid = root.querySelector('video');
    if (!btn || !vid) return;
    btn.addEventListener('click', function () {
      vid.controls = true;
      root.classList.add('is-playing');
      var p = vid.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked: controls are there */ });
    });
    vid.addEventListener('pause', function () { root.classList.remove('is-playing'); });
  }

  /* ---------- Sound toggle for an autoplaying video ----------------------
     Autoplay only works muted, so the clip starts silent and the viewer turns
     the sound on themselves. -------------------------------------------- */
  function initVideoSound(root) {
    if (root.dataset.cbpSoundReady === '1') return;
    root.dataset.cbpSoundReady = '1';
    var btn = root.querySelector('[data-cbp-video-sound-toggle]');
    var vid = root.querySelector('video');
    if (!btn || !vid) return;
    var label = btn.querySelector('[data-cbp-video-sound-label]');

    function sync() {
      root.classList.toggle('is-muted', vid.muted);
      btn.setAttribute('aria-pressed', vid.muted ? 'true' : 'false');
      if (label) label.textContent = vid.muted ? 'Turn sound on' : 'Turn sound off';
    }

    btn.addEventListener('click', function () {
      vid.muted = !vid.muted;
      if (!vid.muted && vid.paused) {
        var p = vid.play();
        if (p && p.catch) p.catch(function () { /* nothing more to do */ });
      }
      sync();
    });
    vid.addEventListener('volumechange', sync);
    sync();
  }

  /* ---------- Marquee: clone the track so the loop has no gap ------------ */
  function initMarquee(root) {
    if (root.dataset.cbpReady === '1') return;
    root.dataset.cbpReady = '1';
    var track = root.querySelector('[data-cbp-marquee-track]');
    if (!track) return;

    /* The keyframe slides each copy left by its own full width, so the loop is
       only seamless while the copies laid end to end cover the viewport twice
       over. A short track (a handful of logos on a wide screen) therefore needs
       more than one clone. Capped so a nearly-empty track cannot run away. */
    var one = track.getBoundingClientRect().width;
    var need = root.getBoundingClientRect().width * 2;
    var copies = 1;
    if (one > 0) copies = Math.min(12, Math.max(1, Math.ceil(need / one)));

    for (var i = 0; i < copies; i++) {
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-cbp-marquee-track');
      track.parentNode.appendChild(clone);
    }

    watchMarquee(root, track);
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Some builds of iOS Safari drop a long-running transform animation on a very
     wide element and leave the strip sitting still, with no error. Rather than
     guess at the trigger, watch whether the strip has actually moved and, if it
     has not, drive it from a rAF loop instead. Anyone who asked for reduced
     motion is left alone: a still ticker is the correct answer for them. */
  function watchMarquee(root, track) {
    if (prefersReducedMotion()) return;

    function transformOf(el) {
      var t = getComputedStyle(el).transform;
      return t && t !== 'none' ? t : '';
    }

    function check() {
      var before = transformOf(track);
      setTimeout(function () {
        if (transformOf(track) !== before) return;        // it is running
        if (prefersReducedMotion()) return;
        if (track.getBoundingClientRect().width < 1) return;  // nothing laid out yet
        driveMarquee(root);
      }, 600);
    }

    // Give the CSS animation a moment to start before judging it.
    if (document.readyState === 'complete') setTimeout(check, 400);
    else window.addEventListener('load', function () { setTimeout(check, 400); });
  }

  function driveMarquee(root) {
    if (root.dataset.cbpMarqueeJs === '1') return;
    root.dataset.cbpMarqueeJs = '1';

    var tracks = root.querySelectorAll('.cbp-marquee__track, .cbp-logos__track');
    if (!tracks.length) return;

    var width = tracks[0].getBoundingClientRect().width;
    if (!width) return;

    var seconds = parseFloat(getComputedStyle(tracks[0]).animationDuration) || 46;
    var pxPerMs = width / (seconds * 1000);

    each(tracks, function (t) { t.style.animation = 'none'; });

    var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var paused = false;
    if (canHover) {
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
    }

    var offset = 0;
    var last = null;
    function step(now) {
      if (last === null) last = now;
      var dt = now - last;
      last = now;
      if (!paused) {
        offset -= pxPerMs * dt;
        if (offset <= -width) offset += width;
      }
      for (var i = 0; i < tracks.length; i++) {
        tracks[i].style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Anchor scrolling that clears the sticky header ------------- */
  function initAnchors() {
    if (document.documentElement.getAttribute('data-cbp-anchors') === '1') return;
    document.documentElement.setAttribute('data-cbp-anchors', '1');

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !a.closest('.cbp')) return;
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var target = document.getElementById(id.slice(1));
      if (!target) return;
      e.preventDefault();

      function offsetTop() {
        return target.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 8;
      }
      var goal = offsetTop();
      window.scrollTo({ top: goal < 0 ? 0 : goal, behavior: 'smooth' });

      // Lazily-loaded images further down can change the page height while the
      // smooth scroll is still running, leaving the target short of the mark.
      // Wait for the scroll to settle, then nudge if it is still off.
      var last = -1;
      var ticks = 0;
      var settle = setInterval(function () {
        var y = window.pageYOffset;
        ticks += 1;
        if (y === last || ticks > 40) {
          clearInterval(settle);
          var residual = target.getBoundingClientRect().top - headerHeight() - 8;
          if (Math.abs(residual) > 4) window.scrollBy({ top: residual, behavior: 'auto' });
        }
        last = y;
      }, 60);

      if (history.replaceState) history.replaceState(null, '', id);
    });
  }

  /* ---------- Boot ------------------------------------------------------- */
  function boot(scope) {
    var ctx = scope || document;
    each(ctx.querySelectorAll('.cbp-header-outer'), initHeader);
    each(ctx.querySelectorAll('details.cbp-panel, details.cbp-acc'), initDetails);
    each(ctx.querySelectorAll('[data-cbp-tabs]'), initTabs);
    each(ctx.querySelectorAll('[data-cbp-gallery]'), initGallery);
    each(ctx.querySelectorAll('[data-cbp-qty]'), initQty);
    each(ctx.querySelectorAll('product-form'), initVariants);
    each(ctx.querySelectorAll('[data-cbp-carousel]'), initCarousel);
    each(ctx.querySelectorAll('[data-cbp-video]'), initVideo);
    each(ctx.querySelectorAll('[data-cbp-marquee]'), initMarquee);
    each(ctx.querySelectorAll('[data-cbp-video-sound]'), initVideoSound);
    each(ctx.querySelectorAll('[data-cbp-video-native]'), initNativeVideo);
    initModals();
    initAnchors();
  }

  window.CBP = { boot: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // The Shopify theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    boot(e.target);
  });
})();
